module.exports = __webpack_public_path__ + "img/exp4.f5f4761f.png";